import { useQuery } from '@tanstack/react-query';

import { useApplicationFetchers } from '../../fetchers/use-application-fetchers';
import { jobArchitectureKeys } from './query-keys';

export const useTaskManagementClusters = ({ architectureId }: { readonly architectureId: string | undefined }) => {
    const { fetchTaskManagementClusters } = useApplicationFetchers();

    return useQuery({
        enabled: architectureId !== undefined,
        queryFn: async () => {
            const result = await fetchTaskManagementClusters({ architectureId: architectureId ?? '' });

            if (result.isErr) {
                throw result.error;
            }

            return result.value;
        },
        queryKey: jobArchitectureKeys.taskManagementClusters(architectureId ?? ''),
        throwOnError: false,
    });
};
